import 'imgix.js'
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/optimumx/ls.optimumx'

// set imgix options
window.imgix = window.imgix || {}
window.imgix.config = window.imgix.config || {}
window.imgix.config.host = 'shedd-production.imgix.net'
window.imgix.config.useHttps = true
window.imgix.config.srcAttribute = null // base64 placeholder gif currently in use
window.imgix.config.srcsetAttribute = 'data-srcset'
window.imgix.config.sizesAttribute = 'data-sizes'
window.imgix.config.sizesAttribute = null // lazysizes needs to handle this
window.imgix.config.defaultParams = {
  auto: 'format,compress',
  fit: 'crop'
}

// set lazysizes options
window.lazySizesConfig = window.lazySizesConfig || {}
lazySizesConfig.init = false

// ensure imgix.js and lazysizes execute in the correct order
imgix.init()
lazySizes.init()
